<template>
  <Head :headHeight="44" :title="title" />
  <div class="content">
    <el-result title="404" sub-title="抱歉，请求错误">
      <template #icon>
        <el-image
          :src="PathError"
        />
      </template>
      <template #extra>
        <el-button type="primary" @click="onBack">返回</el-button>
      </template>
    </el-result>
  </div>
</template>

<script lang="ts" setup>
import router from "@/router";
import Head from "@/components/head/Head.vue";
import PathError from "@/assets/images/404.png"
import { ref } from "vue";

const title = ref("错误页面");
function onBack() {
  router.push("/login");
}
</script>

<style lang="less" scoped>
.content {
  height: calc(100vh - 44px);
}
</style>
